import React from "react";
import { Box } from "@mui/material";
import { Button, Card, Modal, Select } from "@gpstrackit/gtc-react-controls";
import { CarouselComp as Carousel } from "Modules/.common/components/Corousel";
import { useIntl } from "react-intl";

export const AssignFaceToDriver = ({
  openModal,
  seOpenModal,
  setDriverSelected,
  driverSelected,
  selected,
  favoriteUrl,
  setFavoriteUrl,
  drivers,
  assignDrivers
}) => {
  const { messages } = useIntl();

  return (
    <Modal
      closeButton
      open={openModal}
      footer={
        <div>
          <Button
            onClick={() => {
              seOpenModal(false);
              setDriverSelected();
            }}
            style={{ marginRight: 8 }}
            variant="secondary"
          >
            close
          </Button>
          <Button
            isDisabled={!driverSelected ? true : false}
            onClick={() => {
              seOpenModal(false);
              assignDrivers();
            }}
            variant="primary"
          >
            {messages["assign"]}
          </Button>
        </div>
      }
      handleClose={() => {
        seOpenModal(false);
        setDriverSelected();
      }}
      position="right"
      size="small"
      title={messages["settingsDriver_driversFacesAssign"]}
    >
      <Box display="flex" flexDirection="column" padding="15px">
        <div
          style={{
            position: "absolute",
            zIndex: "1",
            background: "white",
            marginTop: "-15px",
            paddingTop: "15px",
            marginBottom: "5px",
          }}
        >
          <Select
            label={messages["settingsDriver_driversFacesSelectDriver"]}
            name="Drivers"
            onChange={(e) => setDriverSelected(e)}
            options={drivers}
            placeholder="Drivers"
            showPillsOutside
            showSelection
            isSearchable
            style={{
              width: "400px",
            }}
            textField="name"
            value={driverSelected}
            valueField="driverId"
            
          />
        </div>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          marginTop="75px"
        >
          {selected.map((item) => {
            return (
              <div style={{ marginBottom: "10px", zIndex: 0 }}>
                <Card heigth="300px">
                  <Carousel
                    selectedFavorite={favoriteUrl}
                    setSelectedFavorite={setFavoriteUrl}
                    item={item}
                    expandImage
                  />
                </Card>
              </div>
            );
          })}
        </Box>
      </Box>
    </Modal>
  );
};
